// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___tQt0h {
    display: flex;
    flex-direction: row;
    margin-top: 8px;
    margin-bottom: 8px;
}

.style__filled___Gitvm {
    display: flex;
    background-color: var(--primary-color);
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    border-right: 1px solid white;
    height: 8px;
}

.style__empty___dWK94 {
    display: flex;
    background-color: lightgrey;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    height: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProgressBar/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,6BAA6B;IAC7B,gCAAgC;IAChC,WAAW;AACf","sourcesContent":[".container {\n    display: flex;\n    flex-direction: row;\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n.filled {\n    display: flex;\n    background-color: var(--primary-color);\n    border-top-left-radius: 20px;\n    border-bottom-left-radius: 20px;\n    border-right: 1px solid white;\n    height: 8px;\n}\n\n.empty {\n    display: flex;\n    background-color: lightgrey;\n    border-top-right-radius: 20px;\n    border-bottom-right-radius: 20px;\n    height: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___tQt0h`,
	"filled": `style__filled___Gitvm`,
	"empty": `style__empty___dWK94`
};
export default ___CSS_LOADER_EXPORT___;
